import { Provider } from '@angular/core';
import { AppInsightsSink, ConsoleSink } from '@timechef/core/logging/sinks';
import { Sink } from '@timechef/core/logging/sinks/sink';
import { InAppSink } from './sinks/in-app-sink';

export * from './log-entry';
export * from './log.service';

export const SINK_PROVIDERS: Provider[] = [
  {
    provide: Sink,
    useClass: ConsoleSink,
    multi: true,
  },
  {
    provide: Sink,
    useClass: AppInsightsSink,
    multi: true,
  },
  {
    provide: Sink,
    useClass: InAppSink,
    multi: true,
  },
];
